import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneDownOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.151 8.38c.3.078.524.315.638.614l.69 1.797 3.77.706c2.613-4.878-2.026-6.998-7.26-6.997-5.233.001-9.845 2.123-7.239 7l3.77-.708.67-1.789c.113-.303.34-.545.643-.624.427-.11 1.147-.243 2.156-.243 1.014 0 1.736.133 2.162.244M7.99 6.736c-1.133 0-1.97.149-2.508.288-.842.218-1.368.862-1.602 1.488l-.393 1.05-1.905.357c-.189-.57-.21-1.009-.154-1.34.078-.47.339-.899.857-1.298 1.116-.86 3.2-1.38 5.706-1.381 2.505 0 4.597.52 5.72 1.38.522.4.784.83.863 1.299.055.33.035.768-.154 1.338l-1.913-.358-.41-1.067c-.237-.618-.76-1.25-1.592-1.467-.537-.14-1.378-.29-2.515-.289"
                fill="currentColor"
            />
        </g>
    </svg>
));
PhoneDownOutlinedSize16Glyph.displayName = 'PhoneDownOutlinedSize16Glyph';
